<template>
  <div class="u-wrap">
    <div class="heard">
      <van-tabs v-model="currentTab" @change="change" color="#3E78F7" line-width="70px">
        <van-tab v-for="(item, index) in tabList" :key="index" :title="item.text"></van-tab>
      </van-tabs>
    </div>
    <div class="u-content-wrap">
      <van-empty v-if="dataList.length == 0" style="width: 100%" description="暂无数据" />
      <van-pull-refresh v-else v-model="refreshing" @refresh="onRefresh">
        <van-list v-model="loading" offset="20" :finished="finished" finished-text="" @load="onLoad">
          <div style="width: 100vw;">
             <xjsj-card :list="dataList" @click="clickItem"></xjsj-card>
          </div>
        </van-list>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
import xjsjCard from '@/views/common/xjsj-card.vue'
import { getAction, postAction, postParam } from '@/api/manage'
import { matchType } from '@/utils/util'

export default {
  components: {
    xjsjCard,
  },
  data() {
    return {
      currentTab: 0,
      tabList: [
        { text: '组织建设史', code: '01' },
        { text: '革命、建设发展史', code: '02' },
        { text: '长武党史', code: '03' },
      ],
      dataList: [],
      list: [],
      loading: false,
      finished: false,
      refreshing: false,
      pageNo: 0,
      type: '01',
      wxType: '01',
    }
  },
  created() {
    this.onRefresh()
  },
  computed: {},
  methods: {
    change(index) {
      this.current = index
      this.wxType = this.tabList[index].code
      this.onRefresh()
    },
    getData() {
      let params = {  pageNo: this.pageNo, fblx: this.wxType};
      getAction('/zhshj/djyldsg/page', params).then((res) => {
        if(res.success){
            if (this.refreshing) {
          this.dataList = []
          this.refreshing = false
        }
        let list = res.result.records;
        this.dataList = this.dataList.concat(list)
        this.loading = false
        if (res.result.pages <= this.pageNo) {
          this.finished = true
        }
        }
       
      })
    },
    onLoad() {
      this.pageNo++
      this.getData()
    },
    clickItem(item) {
       this.$store.state.dsgView = item
      this.$router.push({
        path: '/dqfw/dsg-view',
      })
    },
    onRefresh() {
      // 清空列表数据
      this.finished = false
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true
      this.pageNo = 0
      this.refreshing = true
      this.onLoad()
    },
  },
}
</script>

<style lang="less" scoped>
.u-wrap {
  height: 100vh;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  padding-top: 44px;
  background-color: #f5f5f5;
}
.heard {
  position: fixed;
  top: 0px;
  left: 0px;
  width: 100%;
  z-index: 1;
}
.u-content-wrap {
  flex: 1;
  display: flex;
}
</style>
